<template>
    <section class="relative mx-auto" :style="{ minHeight: height }">
        <!-- 背景层 -->
        <div id="box" class="z-20 absolute inset-0 flex items-center justify-center w-full h-full overflow-hidden">
        </div>

        <!-- 渐变层 -->
        <div class="z-30 absolute inset-0 bg-gradient-to-t from-neutral-950 via-transparent to-transparent"></div>

        <!-- 内容层 -->
        <slot></slot>
    </section>
</template>
<script setup lang="ts">
import { BlurGradientBg } from '@/assets/js/BlurGradientBg.module.js';

const props = defineProps({
    // 默认 auto：不强制高度，section 随内容（与历史行为一致，index/contact/redeem 不受影响）。
    // 需要让动画背景有确定高度的页面（如 pricing：内容异步加载，画布会在内容到位前
    // 以过矮尺寸初始化）显式传入，作为 min-height。
    height: {
        type: String,
        default: 'auto'
    }
});

const utils = useUtils()
const colorbgCanvas = ref<HTMLElement | null>(null)

onMounted(() => {
    try {
        let colorbg = new BlurGradientBg({
            dom: "box",
            colors: ["#0a0a0a", "#6b1b00", "#0a0a0a", "#0a0a0a"],
            loop: true
        })
    } catch (error) {
        console.log('load color bg error', error)
    }
});
</script>